module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "linen",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer007"
    }
  }, [_c('div', {
    staticClass: "content-title",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('h1', {
    staticClass: "Front-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital1#_idTextAnchor000"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital2#_idTextAnchor002"
    }
  }, [_vm._v("Why Moon Milks? ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital2#_idTextAnchor001"
    }
  }, [_vm._v("The Milky Way")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital2#_idTextAnchor003"
    }
  }, [_vm._v("Milky Basics & How To’s")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital2#_idTextAnchor006"
    }
  }, [_vm._v("Choosing Add-Ins ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital2#_idTextAnchor018"
    }
  }, [_vm._v("Garnishes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital2#_idTextAnchor022"
    }
  }, [_vm._v("Floral Water Moonfusions")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital2#_idTextAnchor023"
    }
  }, [_vm._v("Dropping into the Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital2#_idTextAnchor024"
    }
  }, [_vm._v("Bedtime Snack Tips")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor025"
    }
  }, [_vm._v("Starlit Soothers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor026"
    }
  }, [_vm._v("All The Thyme In The World Moon Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor027"
    }
  }, [_vm._v("Mindful Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor028"
    }
  }, [_vm._v("Balance Brew")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor029"
    }
  }, [_vm._v("Calming Cardamom Moon Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor030"
    }
  }, [_vm._v("Magic Hour")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor031"
    }
  }, [_vm._v("Sleepytime Chai")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor033"
    }
  }, [_vm._v("Blushing Moon Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor034"
    }
  }, [_vm._v("Matcha Brownie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor035"
    }
  }, [_vm._v("Sleeping Beauty")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor036"
    }
  }, [_vm._v("Musing Mango")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor037"
    }
  }, [_vm._v("Hunger Moon Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor038"
    }
  }, [_vm._v("Rose–Earl Grey Latte")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor039"
    }
  }, [_vm._v("Blue Moonfusion")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital3#_idTextAnchor040"
    }
  }, [_vm._v("Kiwi Dreamin’")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor041"
    }
  }, [_vm._v("Night Owls")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor042"
    }
  }, [_vm._v("Matcha Moon Latte")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor043"
    }
  }, [_vm._v("Green Goddess")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor044"
    }
  }, [_vm._v("Golden Moon Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor045"
    }
  }, [_vm._v("Slumber Shots")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor046"
    }
  }, [_vm._v("Strawberry Elderflower Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor047"
    }
  }, [_vm._v("Fairy Nectar")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor048"
    }
  }, [_vm._v("Love Brew")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor049"
    }
  }, [_vm._v("Lavender Hot Chocolate")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor050"
    }
  }, [_vm._v("Enter the Night Latte")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor051"
    }
  }, [_vm._v("Midnight Reverie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor052"
    }
  }, [_vm._v("Maple Dreamin’")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor053"
    }
  }, [_vm._v("Dandy Shandy")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor054"
    }
  }, [_vm._v("Into the Blue")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor055"
    }
  }, [_vm._v("Crushed Velvet")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital4#_idTextAnchor056"
    }
  }, [_vm._v("Unicorn Sunset")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor057"
    }
  }, [_vm._v("Calming Classics")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor058"
    }
  }, [_vm._v("Cinnamon & Sugar Moon Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor059"
    }
  }, [_vm._v("Verdant Luna")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor060"
    }
  }, [_vm._v("Let’s Get Figgy with It")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor061"
    }
  }, [_vm._v("Cozy Cacao")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor062"
    }
  }, [_vm._v("Pretty in Purple Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor063"
    }
  }, [_vm._v("Nuts for Moon Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor064"
    }
  }, [_vm._v("PB & Jelly Time")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor065"
    }
  }, [_vm._v("Peaches & Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor067"
    }
  }, [_vm._v("Mama’s Malty Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor068"
    }
  }, [_vm._v("Apple Pie in the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor071"
    }
  }, [_vm._v("Rosie Chai")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor072"
    }
  }, [_vm._v("Twilight Delight")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor073"
    }
  }, [_vm._v("Banana Brûlée")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital5#_idTextAnchor074"
    }
  }, [_vm._v("Italian Sugar Clouds ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital6#_idTextAnchor075"
    }
  }, [_vm._v("Noddy Toddies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital6#_idTextAnchor076"
    }
  }, [_vm._v("Lavender Honey Nightcap")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital6#_idTextAnchor077"
    }
  }, [_vm._v("Moonlight Mulled Cherry Toddy")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital6#_idTextAnchor078"
    }
  }, [_vm._v("Tipsy Black Forest Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital6#_idTextAnchor080"
    }
  }, [_vm._v("Nod Off Nog")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital6#_idTextAnchor081"
    }
  }, [_vm._v("Cereal Milk & Cookies Cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Moon_Milk_Digital6#_idTextAnchor082"
    }
  }, [_vm._v("Horchata Latte")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('h1', {
    staticClass: "Intro-head",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "Normal1"
  }, [_vm._v("We would like to thank all those who appreciate the magic of the moon and all her wondrous gifts—and the following folks for their moon milk inspiration: ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Lesley Gilbert for her moon-inspired water color art, and for sharing herbs from her apothecary, Sacred Spaces Co.; Megan Elizondo of Nutmeg Photography for her constant positive vibes and beautiful images; and Leigh Lamitola for supporting our vision and helping it come to life. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "Photo of dried flowers and other dried ingredients with a candle, and a spoon with the words Don't let the Muggles get you down.",
      "src": "image/night_owl-unicorn_sunset_outtake.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c103422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Moon_Milk_Digital-1.vue
// module id = 63
// module chunks = 0